<template>
  <quiz-figure :image_source="qImage" alt="イメージ" />
</template>

<script>
import Util from '@/modules/Util'
import QuizFigure from '@/components/QuizFigure'

export default {
  name: 'QuizQuestionImage',
  components: {
    QuizFigure
  },
  props: {
    qm_id: {
      type: Number,
      required: true
    }
  },
  computed: {
    qImage () {
      return Util.getQuestionImage(this.qm_id)
    }
  }
}
</script>

<style scoped>

</style>
